module.exports = __webpack_public_path__ + "img/renova.7178f4f2.svg";